export default {
      id: "blog-usage",
      viewBox: "0 0 35 29",
      url: __webpack_public_path__ + "app/svg/sprite.svg#blog",
      toString: function () {
        return this.url;
      }
    }